import React from 'react';

const socials = [
  { name: 'INSTAGRAM', url: 'https://www.instagram.com/apertureslate/' },
  { name: 'THREADS', url: 'https://www.threads.com/@apertureslate' },
];

export default function ContactPage() {
  return (
    <div
      style={{
        minHeight: '100vh',
        backgroundColor: '#050505',
        color: '#fff',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}
    >
      {/* Nav */}
      <div style={{ borderBottom: '1px solid #111', padding: '14px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <a href="/#/" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: '12px' }}>
          <img src="/logo.png" alt="Aperture Slate" style={{ height: '32px' }} />
          <span style={{ fontSize: '13px', fontWeight: '900', letterSpacing: '0.2em', color: '#fff' }}>APERTURE SLATE</span>
        </a>
        <a href="/#/" style={{ fontSize: '11px', letterSpacing: '0.15em', color: '#444', textDecoration: 'none', textTransform: 'uppercase' }}>
          ← Main Site
        </a>
      </div>

      <div style={{ maxWidth: '680px', margin: '0 auto', padding: '80px 24px' }}>
        <p style={{ fontSize: '11px', letterSpacing: '0.4em', color: '#00aaff', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '16px' }}>
          Aperture Slate // Get in Touch
        </p>
        <h1 style={{ fontSize: 'clamp(2.5rem, 7vw, 4rem)', fontWeight: '900', letterSpacing: '-0.03em', lineHeight: '0.95', textTransform: 'uppercase', margin: '0 0 48px 0' }}>
          Contact<br /><span style={{ color: '#333' }}>Michael Kuper</span>
        </h1>

        {/* Cards */}
        <div style={{ display: 'grid', gap: '16px' }}>

          {/* Tools access */}
          <div style={{ border: '1px solid #1a1a1a', backgroundColor: '#0a0a0a', padding: '32px' }}>
            <p style={{ fontSize: '11px', letterSpacing: '0.3em', color: '#00aaff', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '12px' }}>
              Filmmaker Tools Access
            </p>
            <p style={{ color: '#888', fontSize: '0.9rem', lineHeight: '1.7', marginBottom: '20px' }}>
              Our professional tools — budget estimators, SAG tier finder, festival tracker, and more — are available by invitation. Send a message to request your access code.
            </p>
            <a
              href="mailto:hello@apertureslate.org?subject=Filmmaker Tools Access Request&body=Hi Michael,%0D%0A%0D%0AI'd like to request access to the Aperture Slate filmmaker tools.%0D%0A%0D%0AName:%0D%0AProduction:%0D%0A"
              style={{
                display: 'inline-block',
                padding: '14px 28px',
                background: '#fff',
                color: '#000',
                textDecoration: 'none',
                fontWeight: '800',
                fontSize: '0.75rem',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
              }}
            >
              Request Tool Access →
            </a>
          </div>

          {/* Investment inquiries */}
          <div style={{ border: '1px solid #1a1a1a', backgroundColor: '#0a0a0a', padding: '32px' }}>
            <p style={{ fontSize: '11px', letterSpacing: '0.3em', color: '#00aaff', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '12px' }}>
              Investment Inquiries
            </p>
            <p style={{ color: '#888', fontSize: '0.9rem', lineHeight: '1.7', marginBottom: '20px' }}>
              Interested in supporting the $1M Aperture Slate production pipeline? Reach out to discuss investment opportunities and receive our full prospectus.
            </p>
            <a
              href="mailto:hello@apertureslate.org?subject=Investment Inquiry — Aperture Slate"
              style={{
                display: 'inline-block',
                padding: '14px 28px',
                border: '1px solid #333',
                color: '#fff',
                textDecoration: 'none',
                fontWeight: '800',
                fontSize: '0.75rem',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
              }}
            >
              Discuss Investment →
            </a>
          </div>

          {/* General */}
          <div style={{ border: '1px solid #1a1a1a', backgroundColor: '#0a0a0a', padding: '32px' }}>
            <p style={{ fontSize: '11px', letterSpacing: '0.3em', color: '#00aaff', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '12px' }}>
              General Inquiries
            </p>
            <p style={{ color: '#888', fontSize: '0.9rem', lineHeight: '1.7', marginBottom: '20px' }}>
              Press, partnerships, collaborations, or anything else — get in touch directly.
            </p>
            <a
              href="mailto:hello@apertureslate.org"
              style={{
                display: 'block',
                fontSize: '1.1rem',
                fontWeight: '900',
                color: '#fff',
                textDecoration: 'none',
                letterSpacing: '0.02em',
                marginBottom: '20px',
              }}
            >
              hello@apertureslate.org
            </a>
            <div style={{ display: 'flex', gap: '12px' }}>
              {socials.map((s) => (
                <a
                  key={s.name}
                  href={s.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    fontSize: '11px',
                    fontWeight: 'bold',
                    letterSpacing: '0.15em',
                    color: '#00aaff',
                    textDecoration: 'none',
                    textTransform: 'uppercase',
                  }}
                >
                  {s.name} →
                </a>
              ))}
            </div>
          </div>

          {/* 2027 Initiative */}
          <div style={{ border: '1px solid #222', backgroundColor: '#080808', padding: '24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px' }}>
            <div>
              <p style={{ fontSize: '11px', letterSpacing: '0.3em', color: '#555', fontWeight: 'bold', textTransform: 'uppercase', marginBottom: '6px' }}>
                Filmmaker?
              </p>
              <p style={{ color: '#666', fontSize: '0.85rem', margin: 0 }}>Submit your project to the 2027 Film Initiative.</p>
            </div>
            <a
              href="/#/submit"
              style={{
                padding: '12px 24px',
                backgroundColor: '#00aaff',
                color: '#fff',
                textDecoration: 'none',
                fontWeight: '800',
                fontSize: '0.75rem',
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                whiteSpace: 'nowrap',
              }}
            >
              2027 Initiative →
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
